export default __webpack_public_path__ + "static/media/roof.3a924327.webp";